import React,{ useState} from 'react'
import Logo from '../../img/intelli X Logo.png'
import { NavLink } from 'react-router-dom' 
import { HiOutlineSupport } from 'react-icons/hi' 
import { MdVerified } from 'react-icons/md' 
import { AiFillEye } from 'react-icons/ai' 
import { AiFillEyeInvisible } from 'react-icons/ai' 
import { HiOutlineArrowLongRight } from 'react-icons/hi2' 
import { AiOutlineCheckCircle } from 'react-icons/ai' 
import { AiOutlineCloudUpload } from 'react-icons/ai' 
import { RxCross2 } from 'react-icons/rx' 
import tt from '../../img/tt1.png';
import tt2 from '../../img/tt2.png';
import tt3 from '../../img/tt3.png';
import tt4 from '../../img/tt4.png'; 
 import '../../App.css'
 import "./Sign.css" 



const SignUp = () => {


  const [Banner, setBanner] = useState(" ");
  const [Banner1, setBanner1] = useState(""); 

  const [count, setcount] = useState(1) 

  

    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState(""); 

    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }  


    const [passwordType2, setPasswordType2] = useState("password");
    const [passwordInput2, setPasswordInput2] = useState(""); 

    const handlePasswordChange2 = (evnt) => {
        setPasswordInput2(evnt.target.value);
    }
    const togglePassword2 = () => {
        if (passwordType2 === "password") {
            setPasswordType2("text")
            return;
        }
        setPasswordType("password")
    } 
 
 

  return (
    <div className='bg'> 

    <div   style={{display:count==1?"block":"none"}}> 

    <div className='container' style={{paddingTop:'100px'}}>
     <div className='row'>
      <div className='col-lg-2 col-md-12 col-sm-12' >
      <div>
       <img src={Logo} alt='img' style={{width:'90%'}}/>
      </div>

      </div>

      <div className='col-lg-7 col-md-12 col-sm-12' >
      </div>

      <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

      <h5 className='text-end'>Already a Customer  <NavLink to='' style={{textDecoration:'none'}}> Login </NavLink></h5>

      <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
      </div>

     </div>
    </div>
    <div className='container mt-4 '>
     <div className='row'>
      <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

      <div className='row '>
       <div className='col-lg-12 col-sm-12'>
        
              <div className='card p-3' style={{border:'none'}}>

              <h4>What is your Email ID ?</h4>
               <div className='card-body'>

               <div className='my-5'>
               <input type="email" class="form-control py-2" placeholder="john.doe@gmail.com" style={{border:'1px solid #EDEDED'}}/> 
               </div> 

               <div className='my-5'> 
                  <button style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
                  onClick={()=>{setcount(count+1)}} >Get OTP</button>
               </div> 

               </div>
              </div>

       </div>
      </div>
        
       
      <p className='text-center'>  By Proceeding you Agree to <NavLink style={{textDecoration:'none'}}> our Privacy Policy , User <br/>License Agreement & Data Privacy Policy</NavLink></p>
      </div>
     </div>
    </div>

    </div>     


    <div style={{display:count===2? "block" : "none"}}>

    <div className='container' style={{paddingTop:'100px'}}>
    <div className='row'>
     <div className='col-lg-2 col-md-12 col-sm-12' >
     <div>
      <img src={Logo} alt='img' style={{width:'90%'}}/>
     </div>

     </div>

     <div className='col-lg-7 col-md-12 col-sm-12' >
     </div>

     <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

     <h5 className='text-end'>Already a Customer  <NavLink to='' style={{textDecoration:'none'}}> Login </NavLink></h5>

     <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
     </div>

    </div>
   </div>
   <div className='container mt-4'>
    <div className='row'>
     <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

     <div className='row'>
      <div className='col-lg-12 col-sm-12'>
       
             <div className='card p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>

             <h4>Enter 6 Digit OTP</h4>
             <h6 className='pt-3'>Received on : jxxxxxxx@gmail.com</h6>
             <h6 className='' style={{color:'#3572FA'}}>Change Mail</h6>

              <div className='card-body'>

              <div className='my-3' style={{display:'flex', }}>
              <input type="Number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
              </div> 

               <div>
                <h6 className='mt-2' style={{color:'#3572FA', float:'right'}}>Resend OTP</h6>
               </div>

              <div className='mt-5'> 
                 <button  className='mt-5' style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
                 onClick={()=>{setcount(count+1)}} > Verify </button>
              </div> 

              </div>
             </div>

      </div>
     </div>
       
       
     </div>
    </div>
   </div>

    </div>


 

  <div style={{display:count===3? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

    

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>

           <p style={{color:'#767676', textAlign:'center'}}>Email Verified Successfully</p>
           <h6 className='pt-3 text-center'>john.doe@gmail.com <MdVerified style={{color:'#0CCE7D', fontSize:'20px'}}/></h6>
           

            <div className='card-body'>

             
             

            <div className='mt-5'> 
               <button   style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Proceed </button>
            </div> 

            </div>
           </div>

    </div>
   </div>
     
     
   </div>
  </div>
 </div>

  </div>





  

  <div style={{display:count===4? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

    

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}> 
          
            <div className='card-body'>
            <h4 className='py-5  '>What is your Contact Number ? </h4> 
             
            <div class="input-group mb-3">
            <span class="input-group-text me-2 py-3" id="basic-addon1" style={{backgroundColor:'transparent', borderRadius:'8px'}}>91 </span>
            <input type="number" class="form-control py-3" placeholder="1 2 3    4 5 6    7 8 9 0" aria-label="Username" aria-describedby="basic-addon1" style={{borderRadius:'8px'}}/>
          </div>

            <div className='mt-5'> 
               <button   style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Get OTP </button>
            </div> 

            </div>
           </div>

    </div>
   </div>
     
     
   </div>
  </div>
 </div>

  </div>

  


  

  <div style={{display:count===5? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>
    
   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

    

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}> 
          
            <div className='card-body'>
            <h4 className='py-5  '>Enter 6 Digit OTP </h4> 
            <h6>Received on : +91 xxx xxx 4391 </h6> 
            <p style={{color:'#3572FA'}}>Change Contact Number</p>
             
            

            <div className='my-3' style={{display:'flex', }}>
            <input type="Number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            <input type="number" maxLength={1} class="form-control m-2"  style={{  width:'12%'}}/> 
            </div> 

            <div>
             <p style={{color:'#3572FA', float:'right'}}>Resend OTP</p>
            </div>

            <div className='mt-5'> 
               <button   style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Verify </button>
            </div> 

            </div>
           </div>

    </div>
   </div>
     
     
   </div>
  </div>
 </div>

  </div>



  <div style={{display:count===6? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' >

    

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>

           <p style={{color:'#767676', textAlign:'center'}}>Contact Number Verified Successfully</p>
           <h4 className='mt-3 text-center'>905898358 <MdVerified className='mb-1' style={{color:'#0CCE7D', fontSize:'20px'}}/></h4>
           

            <div className='card-body'>

             
             

            <div className='mt-5'> 
               <button   style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Proceed </button>
            </div> 

            </div>
           </div>

    </div>
   </div>
     
     
   </div>
  </div>
 </div>

  </div>
 

  <div style={{display:count===7? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' > 

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>

           <h3  > Create Password</h3>
           
           

            <div className='card-body'>

             
            <div className="input-group mb-3">
            <input type={passwordType} onChange={handlePasswordChange} value={passwordInput} name="password" class="form-control py-2" placeholder="Enter Password" style={{borderRadius:'8px'}}/>

            <div className="input-group-btn">
                <button className="btn" onClick={togglePassword}>
                    {passwordType === "password" ? <AiFillEyeInvisible style={{color:'#898989', fontSize:'22px'}}/> : <AiFillEye style={{color:'#898989', fontSize:'22px'}}/>}
                </button>
            </div>
        </div> 

         
        <div className='mt-1 me-2'style={{lineHeight:'10px'}}  >
        <p style={{color:'#c5c5c5'}}>At least 8 Characters </p>
        <p style={{color:'#c5c5c5'}}>1 Uppercase Character  </p>
        <p style={{color:'#c5c5c5'}}>1 Lowercase Character  </p>
        <p style={{color:'#c5c5c5'}}>1 Special Character    </p>
        </div> 


        <div className="input-group mt-4  ">
        <input type={passwordType2} onChange={handlePasswordChange2} value={passwordInput2} name="password" class="form-control py-2" placeholder="Confirm Password" style={{borderRadius:'10px'}}/>

        <div className="input-group-btn">
            <button className="btn" onClick={togglePassword2}>
                {passwordType2 ===   "password" ? <AiFillEyeInvisible style={{color:'#898989',fontSize:'22px'}}/> : <AiFillEye style={{color:'#898989', fontSize:'22px'}}/>}
            </button>
        </div>  
    </div>
         

            <div className='mt-5'> 
               <button   style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Proceed </button>
            </div>  

            </div>
           </div> 
         </div>
      </div>
            
     
   </div>
  </div>
 </div>

  </div>




  


  

  <div style={{display:count===8? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' > 

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>

           <h3> Login </h3>  
            <div className='card-body'> 

            <div class="col-auto mt-5"> 
            <input type="email"   class="form-control py-2"  aria-describedby="passwordHelpInline"
             placeholder='Enter Email/Contact Number'/> 
            </div>

            <div class="col-auto mt-4"> 
            <input type="password"   class="form-control py-2"  aria-describedby="passwordHelpInline"
             placeholder='Enter Password'/> 
            </div>

            <div>
             <p className='mt-2' style={{color:'#3572FA', float:'right', fontWeight:'500'}}>Forgot Password ?</p>
            </div>
        
  
            <div className='mt-5'> 
               <button className='mt-5'  style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'10px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} > Get Started </button>
            </div>  
            
            </div>
           </div> 
         </div>
      </div>
            
     
   </div>
  </div>


 </div>

  </div>









  <div style={{display:count===9? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' > 

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-3 col-md-6 col-sm-12  '>
   
   <div className='mt-4'>
    <h1>I Am a <HiOutlineArrowLongRight style={{fontSize:'38px'}}/></h1>
   </div>   
     
   </div>
  </div>


  <div className='row  mt-4'>
   <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
   <div class="card" style={{width: '100%',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)', border:'none'}}>
   <img src={tt} class="card-img-top" alt="..."/>
   <div class="card-body">
     <h5 class="card-title">Teacher</h5>
     <p class="card-text" style={{color:'#FB1C1C'}}> <RxCross2 className='me-1' style={{border:'1px solid #FB1C1C',borderRadius:'50%', fontSize:'16px'}}/> Automation</p>
     <p class="card-text" style={{color:'#FB1C1C'}}> <RxCross2 className='me-2' style={{border:'1px solid #FB1C1C',borderRadius:'50%', fontSize:'16px'}}/>Payments</p> 



     <div>
      <button style={{backgroundColor:'#3572FA', color:'#fff',borderRadius:'8px', border:'none',width:'100%',padding:'10px 12px'}} onClick={()=>{setcount(count+1)}}>Get Started</button>
     </div>
   </div>
 </div>

   </div>




   <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
   <div class="card" style={{width: '100%',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)', border:'none'}}>
    <div style={{display:'flex', justifyContent:'center'}}>
   <img src={tt2} class="card-img-top" alt="..." style={{width:'80%'}}/>
    </div>
    
   <div class="card-body">
     <h5 class="card-title">Coaching/Training Institute</h5>
     <p class="card-text" style={{color:'#0CCE7D'}}>
      <AiOutlineCheckCircle className='me-1' style={{  fontSize:'16px'}}/> Automation</p>
     <p class="card-text" style={{color:'#0CCE7D '}}>
      <AiOutlineCheckCircle className='me-2' style={{  fontSize:'16px'}}/>Payments</p> 



     <div>
      <button style={{backgroundColor:'#3572FA', color:'#fff',borderRadius:'8px', border:'none',width:'100%',padding:'10px 12px'}} onClick={()=>{setcount(count+1)}}>Get Started</button>
     </div>
   </div>
 </div>

   </div>





  
   <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
   <div class="card" style={{width: '100%',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)', border:'none'}}>
    <div style={{display:'flex', justifyContent:'center'}}>
   <img src={tt3} class="card-img-top" alt="..." style={{width:'100%'}}/>
    </div>
    
   <div class="card-body">
     <h5 class="card-title">School</h5>
     <p class="card-text" style={{color:'#0CCE7D'}}>
      <AiOutlineCheckCircle className='me-1' style={{  fontSize:'16px'}}/> Automation</p>
     <p class="card-text" style={{color:'#0CCE7D '}}>
      <AiOutlineCheckCircle className='me-2' style={{  fontSize:'16px'}}/>Payments</p> 



     <div>
      <button style={{backgroundColor:'#3572FA', color:'#fff',borderRadius:'8px', border:'none',width:'100%',padding:'10px 12px'}} onClick={()=>{setcount(count+1)}}>Get Started</button>
     </div>
   </div>
 </div>

   </div>





   <div className='col-lg-3 col-md-6 col-sm-12 mt-4'> 
   <div class="card" style={{width: '100%',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)', border:'none'}}>
    <div style={{display:'flex', justifyContent:'center'}}>
   <img src={tt4} class="card-img-top" alt="..."   style={{width:'58%'}}/>
    </div>
    
   <div class="card-body">
     <h5 class="card-title">College/University</h5>
     <p class="card-text" style={{color:'#0CCE7D'}}>
      <AiOutlineCheckCircle className='me-1' style={{  fontSize:'16px'}}/> Automation</p>
     <p class="card-text" style={{color:'#0CCE7D '}}>
      <AiOutlineCheckCircle className='me-2' style={{  fontSize:'16px'}}/>Payments</p> 



     <div>
      <button style={{backgroundColor:'#3572FA', color:'#fff',borderRadius:'8px', border:'none',width:'100%',padding:'10px 12px'}} onClick={()=>{setcount(count+1)}} >Get Started</button>
     </div>
   </div>
 </div>

   </div>
  </div>

  
 </div>

  </div>




  
  

  <div style={{display:count===10? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' > 

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>
   
            <div className='card-body'> 


            <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>Name of Institution</label>

            <input type="text" class="form-control py-3" id="exampleFormControlInput1"
             placeholder="Enter Legal Name" style={{border:'1px solid #EDEDED', borderRadius:'8px'}}/>
          </div>


        <div>
        <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>Entity Type</label>

          <select class="form-select py-3" aria-label="Default select example"  style={{border:'1px solid #EDEDED', borderRadius:'8px'}}>
          <option selected>Select Entity Type</option>
          <option value="1">Proprietorship Firm</option>
          <option value="2">One Person Company</option>
          <option value="3">Limited Liability Partnership</option>
          <option value="4">Private Limited</option>
          <option value="5">Widely Held Organization</option>
          <option value="6">Not For Profit  Form 80G Required</option>
        </select>
        </div>


        <div class="mt-3">
        <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>PAN Details</label>

        <input type="text" class="form-control py-3" id="exampleFormControlInput1"
         placeholder="Enter Company PAN Number" style={{border:'1px solid #EDEDED', borderRadius:'8px'}}/>
      </div>


      
      <div class="mt-3">
      <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>TAN Details</label>

      <input type="text" class="form-control py-3" id="exampleFormControlInput1"
       placeholder="Enter Company TAN Number" style={{border:'1px solid #EDEDED', borderRadius:'8px'}}/>
    </div>

    
<div className="row mt-4">
<label className="filelabel" style={{display:Banner.length===2?"none":"block",overflow:"hidden", backgroundColor:'#D9D9D9'}}>
<img src={Banner} style={{width:"100%",height:"auto", }}/>
    <span className="title" style={{color:'#acacac', fontWeight:"600"}}>
    Use React JS Doc Viewer<br/> Library to Display PPT <span sytle={{opacity:'0' }}></span> 
    </span>
    <input className="FileUpload1" id="FileInput"  type="file" onChange={(e)=>{setBanner(URL.createObjectURL(e.target.files[0]), setBanner1(e.target.files[0]))}} style={{opacity:'0'}}/>
</label> 
</div> 

  
            <div className='mt-5'> 
               <button className='   '  style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'15px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} >Proceed to Documentation </button>
            </div>  
            
            </div>
           </div> 
         </div>
      </div>
            
     
   </div>
  </div> 
 </div>

  </div>





  
  
  

  <div style={{display:count===11? "block" : "none"}}>

  <div className='container' style={{paddingTop:'100px'}}>
  <div className='row'>
   <div className='col-lg-2 col-md-12 col-sm-12' >
   <div>
    <img src={Logo} alt='img' style={{width:'90%'}}/>
   </div>

   </div>

   <div className='col-lg-7 col-md-12 col-sm-12' >
   </div>

   <div className='col-lg-3 col-md-12 col-sm-12 mt-3' > 

   <NavLink to='' style={{textDecoration:'none'}}><h6 className='text-end'> <HiOutlineSupport className='me-2 fs-5'  style={{color:'#3572FA'}}/>Get Assistance</h6></NavLink>
   </div>

  </div>
 </div>
 <div className='container mt-4'>
  <div className='row'>
   <div className='col-lg-5 col-md-6 col-sm-12 m-auto'>

   <div className='row'>
    <div className='col-lg-12 col-sm-12'>
     
           <div className='card mt-5 p-3' style={{border:'none',boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)'}}>
   
            <div className='card-body'> 


            <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>GSTIN <span style={{color:'#a9a9a9', fontSize:'14px', fontWeight:'400'}}>Optional</span></label>

            <input type="text" class="form-control py-3" id="exampleFormControlInput1"
             placeholder="Enter 13 Digit GST Number" style={{border:'1px solid #EDEDED', borderRadius:'8px'}}/>
          </div>
 


        <div class="mt-3">
        <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>GST Certificate Optional</label>

  


         <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1" style={{ border:'1px solid #EDEDED' , backgroundColor:'transparent',borderRight:'none',borderRadius:'8px 0px 0px 8px',}}><AiOutlineCloudUpload   style={{fontSize:'20px'}}/></span>
          <input type="text" class="form-control  " id="exampleFormControlInput1"
          placeholder="Upload GST Certificate " style={{border:'1px solid #EDEDED',  borderRadius:'0px 8px 8px 0px', boxShadow:'none', borderLeft:'none', padding:'10px 3px' }}/>
        </div>
      </div>


      
      <div class="mt-3">
      <label for="exampleFormControlInput1" class="form-label" style={{fontSize:'18px', fontWeight:'600'}}>TAN Details</label>

      <input type="text" class="form-control py-3" id="exampleFormControlInput1"
       placeholder="Enter Company TAN Number" style={{border:'1px solid #EDEDED', borderRadius:'8px'}}/>
    </div>

    
<div className="row mt-4">
<label className="filelabel" style={{display:Banner.length===2?"none":"block",overflow:"hidden", backgroundColor:'#D9D9D9'}}>
<img src={Banner} style={{width:"100%",height:"auto", }}/>
    <span className="title" style={{color:'#acacac', fontWeight:"600"}}>
    Use React JS Doc Viewer<br/> Library to Display PPT <span sytle={{opacity:'0'}}></span> 
    </span>
    <input className="FileUpload1" id="FileInput"  type="file" onChange={(e)=>{setBanner(URL.createObjectURL(e.target.files[0]), setBanner1(e.target.files[0]))}} style={{opacity:'0'}}/>
</label> 
</div> 




<div className="row mt-4">

<label className="filelabel2 col-12" 
style={{backgroundColor:"#F5F5F5"}}
 onClick={()=>{}}>

   <span className="title2 d-flex">
   <AiOutlineCloudUpload style={{fontSize:'20px',margin:3}}/>
        Upload GST Certificate
   </span>
   <input className="FileUpload2" id="FileInput2"
    name="booking_attachment2" type="file" accept='.png,.jpg'
     />
</label> 
</div>


  
            <div className='mt-5'> 
               <button className='   '  style={{backgroundColor:'#3572FA', color:"#fff", border:'none', padding:'15px 12px', borderRadius:'10px', width:'100%'}} 
               onClick={()=>{setcount(count+1)}} >Proceed to Documentation </button>
            </div>  
            
            </div>
           </div> 
         </div>
      </div>
            
     
   </div>
  </div> 
 </div>

  </div>


    </div>
  )
}

export default SignUp;
